// Display translation for the mortgage-estimate row labels.
//
// MortgageEstimate.vue and the tables build these labels as DATA, and the data
// doubles as an identifier: the tables, the currencyOrPercent filter and the
// tabs compare it in English ("Total Payment", "Loan to Value", "Fee Detail").
// Translating the data itself would break those comparisons in every other
// language, so the data stays English and only what is RENDERED goes through
// here. Anything not listed - amounts, scenario names, creditor names and the
// industry acronyms (PMI, HOI, HOA, SP) - is returned untouched.
import { t } from "@/i18n";

const LABEL_KEYS = Object.freeze({
  "Purchase Price": "estimate.purchasePrice",
  "Property Value": "estimate.propertyValue",
  "P&I (1st)": "estimate.piFirst",
  "Property Taxes": "estimate.propertyTaxes",
  "Monthly Payment": "estimate.monthlyPayment",
  "Extra Payment": "estimate.extraPayment",
  "Additional Debts": "estimate.additionalDebtsRow",
  "Additional Debt(s)": "estimate.additionalDebts",
  "Total Payment": "estimate.totalPayment",
  "Total Int & MI": "estimate.totalIntMi",
  "Down Pmt": "estimate.downPmt",
  "Loan to Value": "estimate.loanToValue",
  "Closing Costs": "estimate.closingCosts",
  Prepaids: "estimate.prepaids",
  "Earnest Money": "estimate.earnestMoney",
  "Lender Credit": "estimate.lenderCredit",
  "Seller Credit(s)": "estimate.sellerCredits",
  "Cash to Close": "estimate.cashToCloseRow",
  "Fee Detail": "estimate.feeDetail",
});

/**
 * The label to show for an estimate row. Reactive when called during render:
 * `t` reads the active dictionary, so a language switch re-renders it.
 */
export function estimateLabel(value) {
  if (typeof value !== "string") return value;
  const key = LABEL_KEYS[value];
  return key ? t(key) : value;
}
